import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { Logger, OnFeatureInit } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { LaunchDarklyConfig } from './launch-darkly.client-config';
import { LaunchDarklyService } from './launch-darkly.service';

@Injectable()
export class LaunchDarklyBootstrapService implements OnFeatureInit {
    private launchDarklyService = inject(LaunchDarklyService);
    private config = inject(LaunchDarklyConfig);
    private log = inject(Logger);

    private isServer = isPlatformServer(inject(PLATFORM_ID));

    async onFeatureInit() {
        if (this.isServer) {
            return;
        }
        await firstValueFrom(this.config.whenReady);
        if (this.config.clientId) {
            this.launchDarklyService.initialize(this.config.clientId);
        } else {
            this.log.warnRemote('[LaunchDarkly] - ClientId not configured in Dynacon.');
        }
    }
}
